module.exports = __webpack_public_path__ + "img/blake-4.6faf3f6b.jpg";